import Testimonials from "../component/Testimonials/Testimonials"
import Footer from '../component/Footer/Footer'
import HomeCustomTextContent from '../component/HomeCustomTextContent/HomeCustomTextContent'
import ExpertiseSection from '../component/ExpertiseSection/ExpertiseSection'
import HomeProgram from '../component/HomeProgram/HomeProgram'
import HomeApproachText from '../component/HomeApproachText/HomeApproachText'
import HomeHero from '../component/HomeHero/HomeHero'
import Header from '../component/Header/Header'
import MembershipCustomTextContent from "../component/MembershipCustomTextContent/MembershipCustomTextContent"
import ImagesCustomScroll from "../component/ImagesCustomScroll/ImagesCustomScroll"
import SlideScrollContent from "../component/SlideScrollContent/SlideScrollContent"
import FaqSection from "../component/FaqSection/FaqSection"
import TeamLdCare from "../component/TeamLdCare/TeamLdCare"
import TestimonialsNew from "../component/InstaImageGallery/InstaImageGallery"
import MemberShipScrollNew from "../component/MemberShipScrollNew/MemberShipScrollNew"
import SlideScrollContentNew from "../component/SlideScrollContent/SliderScrollContentNew"
import { Helmet } from "react-helmet"

const serviceData=[
    {
        icon:"/images/icons/service-card-icon-1.png",
        iconBox:false,
        heading:"Annual Executive Health Assessment",
        content:"A full-spectrum, multidisciplinary evaluation covering key risk domains and baseline performance.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-2.png",
        iconBox:false,
        heading:"Regular Coaching and Clinical Touchpoints",
        content:"Structured monthly follow-ups and strategy sessions to keep you accountable and aligned.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-3.png",
        iconBox:false,
        heading:"In-Hospital Advocacy",
        content:"Should you require hospitalization, we ensure you’re not navigating alone.",
        btnText:"Learn More",
        btnRef:"/"
    },
    
    {
        icon:"/images/icons/service-card-icon-3.png",
        iconBox:false,
        heading:"Global Health Support",
        content:"Medical coordination anywhere life or work takes you.",
        btnText:"Learn More",
        btnRef:"/"
    },
    
    {
        icon:"/images/icons/service-card-icon-3.png",
        iconBox:false,
        heading:"Dedicated Clinical Team",
        content:"Physicians, naturopaths, physiologists, and health strategists collaborating under one roof.",
        btnText:"Learn More",
        btnRef:"/"
    },
    
    
]

const faqData = [
  {
    title:"Can Canadian citizens access your services?",
    content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
  },
  {
    title:"Can foreign nationals access your program? ",
    content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
  },
  {
    title:"Do you accept families into the program?",
    content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
  },
  {
    title:"Do you work with elderly patients?",
    content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
  },
  {
    title:"Are there any tax benefits to joining?",
    content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
  },
]

const memberShipCustomTextCard=[
   {
        img:"/images/creatives/membership-text-1.png",
        title:"Prevention Over Reaction",
        para:" Up to 70 percent of cardiac events and cancers stem from preventable causes. We intervene early with precision testing, lifestyle interventions, and continuous monitoring."
    },
   {
        img:"/images/creatives/membership-text-new-2.jpg",
        title:"Optimal Health Is a Daily Practice",
        para:" Our clinicians actively coach you in lifestyle and environmental optimization, turning evidence into outcomes."
    },
   {
        img:"/images/creatives/membership-text-new-3.jpg",
        title:"Designed for Longevity",
        para:"Our mission is simple: keep you healthy, high-performing, and independent for as long as possible."
    },
]

function Membership() {
  return (
      <div >
     <Helmet>
        <title>
        Concierge Medicine Toronto | Executive Health Membership
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/membership"
        />
        <meta
          name="description"
          content="Join Toronto’s leading concierge medicine and executive health membership. Enjoy private, physician-led care designed for prevention, longevity, and performance."
        ></meta>

      </Helmet>
      <Header/>
     <HomeHero
      textCtaBlack={true}
      showLogo={false}
      paraH2={true}
      btnText="Book a consultation"
      plainCta={false}
      heading="Raising the bar on personalized care"
      content="A concierge approach to proactive executive healthcare, designed to optimize longevity, performance, and peace of mind."
      btnrefTel="https://booking.thetorontoclinic.com/membership"
      btnCalnedly={true}
      
      calendlyType={1}
     />

      <div className='left-gradient-bottom pt-4'>
        <div className='right-gradient-center'>
          <MembershipCustomTextContent
            cardDataProp={memberShipCustomTextCard}
          />
        </div>
      </div>

      <ImagesCustomScroll/>

      <HomeProgram
        mainCardHeading="A Comprehensive Program Designed to Empower You"
        mainCardPara=" The Toronto Clinic delivers more than healthcare. It delivers a strategy for life. Rooted in precision, personalization, and prevention, our membership program supports your health journey from every angle."
        // btnText="Explore membership"
        btnText="Book a consultation"
        btnRef="/"
        serviceData={serviceData}
        mainCardImg={'/images/creatives/course-main-card-img.png'}
        btnCalnedly={true}
        calendlyType={1}
      />

      {/* <MemberShipScrollNew/> */}

      {/* <SlideScrollContentNew/> */}
     
      <SlideScrollContent/>

      <FaqSection
         heading="Frequently Asked "
         headingBlue="Questions"
          para="Your health deserves clarity and confidence. Explore our most commonly asked questions below or reach out directly. We’re here to help you make informed, empowered decisions every step of the way."
          subHeading=""
          showImg={false}
          faqData={faqData}
          btnText="Book a consultation"
          btnCalnedly={true}
          calendlyType={1}
      />

      <div className='center-gradient-center'>
        {/* <Testimonials/> */}
        <TestimonialsNew/>

       <TeamLdCare
        heading="Team-led"
        spanHeading="care"
        paragraph="for over 15 years, The Toronto Clinic has led the way in preventative, collaborative healthcare. bringing the best minds together, serving those who expect more from medicine."
        btnCalnedly={true}
        calendlyType={1}
        learnMoreLink={"/team"}
       />
      </div>
       <HomeProgram
        mainCardHeading="The path to health begins here, take the first step"
        mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
        // btnText="Explore membership"
        btnText="Book a consultation"
        btnRef="/"
        mainCardImg={"/images/creatives/membership-text-2.png"}
        showList={false}
        leftBottomBorderRadius={true}
        btnCalnedly={true}
        calendlyType={1}
      />

        <Footer
          newsletterSection={false}
        />
</div>
  )
}

export default Membership